export default function () {
	function guid() {
		function _p8(s) {
			let p = (`${Math.random().toString(16)  }000000000`).substr(2, 8);
			return s ? `-${  p.substr(0, 4)  }-${  p.substr(4, 4)}` : p;
		}
		return _p8() + _p8(true) + _p8(true) + _p8();
	}

	// User Info
	window.session_key = Cookies.get("session_key");
	if (window.session_key === undefined) {
		window.session_key = guid();
	}
	Cookies.set("session_key", window.session_key, { expires: 365 });
}
